/**
 * Safe localStorage wrapper that handles sandboxed contexts
 * Prevents SecurityError when localStorage is unavailable
 */

const safeStorage = {
  /**
   * Check if localStorage is available
   */
  isAvailable() {
    try {
      const test = '__storage_test__';
      window.localStorage.setItem(test, test);
      window.localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  },

  /**
   * Safely get an item from localStorage
   * @param {string} key - The key to retrieve
   * @returns {string|null} The value or null if unavailable
   */
  getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      console.warn(`localStorage.getItem failed for key "${key}":`, e.message);
      return null;
    }
  },

  /**
   * Safely set an item in localStorage
   * @param {string} key - The key to set
   * @param {string} value - The value to store
   * @returns {boolean} True if successful, false otherwise
   */
  setItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      console.warn(`localStorage.setItem failed for key "${key}":`, e.message);
      return false;
    }
  },

  /**
   * Safely remove an item from localStorage
   * @param {string} key - The key to remove
   * @returns {boolean} True if successful, false otherwise
   */
  removeItem(key) {
    try {
      window.localStorage.removeItem(key);
      return true;
    } catch (e) {
      console.warn(`localStorage.removeItem failed for key "${key}":`, e.message);
      return false;
    }
  },

  /**
   * Safely clear all localStorage
   * @returns {boolean} True if successful, false otherwise
   */
  clear() {
    try {
      window.localStorage.clear();
      return true;
    } catch (e) {
      console.warn('localStorage.clear failed:', e.message);
      return false;
    }
  }
};

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = safeStorage;
}

// Make available globally
window.safeStorage = safeStorage;

